import React, { useEffect, useState } from "react";
import { getPublicSuport } from "../api/suportApi";

const InfoText = () => {
  const [support, setSupport] = useState(null);

  const fetchSupportInfo = async () => {
    const res = await getPublicSuport();
    if (res?.success) {
      setSupport(res.data);
    }
  };

  useEffect(() => {
    fetchSupportInfo();
  }, []);

  if (!support) return null;

  return (
    <div className="ds-card w-full max-w-3xl mt-2 mb-2">
      <ul className="list-disc list-outside pl-5 text-[13px] leading-5 text-[var(--text-dark)] text-left space-y-1 font-medium">
        {support.title && <li>{support.title}</li>}
        {support.timing && <li>Timing: {support.timing}</li>}
        {support.contacts?.map((c, i) => (
          <li key={i}>
            Contact Number: {c.number}{" "}
            {c.whatsappOnly
              ? "(WhatsApp only)"
              : c.callEnabled
              ? "(WhatsApp & Call)"
              : ""}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default InfoText;
